var map = {
	"./1.jpg": 1231,
	"./2.jpg": 7504,
	"./3.jpg": 8749,
	"./4.jpg": 2550,
	"./5.jpg": 2659,
	"./6.jpg": 6596,
	"./7.jpg": 4753,
	"./8.jpg": 7290
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9119;